// Library
import React, { Component } from "react";

// Components
import { Modal, Button } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { PreferencesContext } from '../../../contexts/PreferencesContext';

class EditModal extends Component {
  static contextType = PreferencesContext;

  render() {
    return (
      <Modal show={this.props.show} onHide={this.props.handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <JoditEditor
            value={this.props.value}
            onChange={this.props.onChange}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.props.handleClose}>
              {this.context.t('action_cancel')}
          </Button>
          <Button variant="primary" onClick={this.props.onSave}>
              {this.context.t('action_save')}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default EditModal;
